import { render, staticRenderFns } from "./AboutMenu.vue?vue&type=template&id=a7581e10&"
import script from "./AboutMenu.vue?vue&type=script&lang=js&"
export * from "./AboutMenu.vue?vue&type=script&lang=js&"
import style0 from "./AboutMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports